import {
  ApiCartUpdateCartEntryQuantityFailedAction,
  ApiCartUpdateCartEntryQuantitySucceededAction,
  apiCartUpdateCartEntryQuantityFailedType,
  apiCartUpdateCartEntryQuantityRequested,
  apiCartUpdateCartEntryQuantitySucceededType
} from '../../api/cart/updateCartEntryQuantityApi';
import {
  UpdateCurrentCartEntryQuantityRequestedAction,
  updateCurrentCartEntryQuantityFailed,
  updateCurrentCartEntryQuantitySucceeded
} from '../../carts/cartsSlice';
import { put, race, select, take } from 'typed-redux-saga';
import { UpdateCartEntryQuantityResult } from '../../../graphql/cart/updateProductQuantityInCartEntry';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';
import getCartCustomOrderTypeForEntries from '../../carts/getCartCustomOrderTypeForEntries';
import selectGeneralSettings from '../../settings/selectors/selectGeneralSettings';

function* updateCurrentCartEntryQuantitySaga({
  payload: { actionId: requestedActionId, customOrderType, entryId, quantity }
}: UpdateCurrentCartEntryQuantityRequestedAction): Generator {
  const actionId: number = generateActionId();
  const { checkoutDeliverySelectionEnabled } = yield* select(selectGeneralSettings);

  yield* put(
    apiCartUpdateCartEntryQuantityRequested({
      actionId,
      customOrderType,
      entryId,
      quantity,
      parentActionId: requestedActionId
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartUpdateCartEntryQuantitySucceededAction>(
        apiCartUpdateCartEntryQuantitySucceededType
      ),
      failed: take<ApiCartUpdateCartEntryQuantityFailedAction>(
        apiCartUpdateCartEntryQuantityFailedType
      )
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const { cart, updatedQuantity }: UpdateCartEntryQuantityResult = succeeded.payload.result;
        const resolvedCustomOrderType = checkoutDeliverySelectionEnabled
          ? getCartCustomOrderTypeForEntries(cart.entries)
          : customOrderType;
        yield* put(
          updateCurrentCartEntryQuantitySucceeded({
            cart: convertCartToStateCart(cart),
            customOrderType: resolvedCustomOrderType,
            entryId,
            requestedActionId,
            requestedQuantity: quantity,
            updatedQuantity,
            sourceCustomOrderType: customOrderType
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          updateCurrentCartEntryQuantityFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default updateCurrentCartEntryQuantitySaga;
